{
  "version": 1,
  "asset_id": "04f97acb-63fe-48b0-82d1-e4d7c129b6fe",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/04f97acb-63fe-48b0-82d1-e4d7c129b6fe/clip-img_2104-poster-sm.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/04f97acb-63fe-48b0-82d1-e4d7c129b6fe/clip-img_2104-poster-sm.webp",
  "original_filename": "clip-img_2104-poster-sm.webp",
  "size": 10614,
  "content_type": "image/webp",
  "created_at": "2026-08-01T21:10:25Z"
}
